export default __webpack_public_path__ + "static/media/color2.37dcd817.jpg";